function isContentEditableTarget(target: EventTarget | null): boolean {
  if (typeof HTMLElement === "undefined" || !(target instanceof HTMLElement)) {
    return false;
  }
  return target.closest("[contenteditable]") != null;
}

export function isAdminSearchHotkey(
  event: {
    key: string;
    metaKey: boolean;
    ctrlKey: boolean;
    shiftKey?: boolean;
    altKey?: boolean;
    defaultPrevented?: boolean;
    target?: EventTarget | null;
  },
  options?: { isContentEditable?: boolean },
): boolean {
  if (event.defaultPrevented) {
    return false;
  }
  if (event.shiftKey || event.altKey) {
    return false;
  }
  if (event.key.toLowerCase() !== "k") {
    return false;
  }
  if (!event.metaKey && !event.ctrlKey) {
    return false;
  }
  const isContentEditable =
    options?.isContentEditable ?? isContentEditableTarget(event.target ?? null);
  return !isContentEditable;
}

export function isModifiedSearchResultClick(event: {
  metaKey: boolean;
  ctrlKey: boolean;
  shiftKey: boolean;
  altKey: boolean;
}): boolean {
  return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
}
